// extracted by mini-css-extract-plugin
module.exports = {"course-code":"App_course-code__1wNjt","course-title":"App_course-title__oXjFr"};